// extracted by mini-css-extract-plugin
export var backdrop = "_bv-1";
export var dragging = "_bv-4";
export var handle = "_bv-6";
export var handleHit = "_bv-5";
export var listEnd = "_bv-8";
export var modalRoot = "_bv-0";
export var sectionHeader = "_bv-a";
export var sheet = "_bv-3";
export var sheetHost = "_bv-2";
export var shortcutColumns = "_bv-7";
export var shortcutSection = "_bv-9";